export default __webpack_public_path__ + "static/media/food-insecure-mig-int.135055f1.csv";